if (!customElements.get('mythos-product')) {
  customElements.define('mythos-product', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('.mythos-form');
      this.variant = this.querySelector('[data-variant]');
      this.button = this.querySelector('[data-submit]');
      this.error = this.querySelector('[data-error-message]');
      this.engraving = this.querySelector('[data-engraving]');
      this.ringToggle = this.querySelector('[data-ring-toggle]');
      if (!this.form || !this.variant) return;
      this.variant.addEventListener('change', () => this.updateVariant(true));
      this.engraving.addEventListener('input', () => {
        this.querySelector('[data-counter]').textContent = `${this.engraving.value.length} / ${this.engraving.maxLength}`;
      });
      if (this.ringToggle) {
        const ringSelect = this.querySelector('[data-ring-variant]');
        const available = Array.from(ringSelect.options).filter(option => !option.disabled);
        this.ringToggle.disabled = !available.length;
        if (ringSelect.selectedOptions[0]?.disabled && available.length) ringSelect.value = available[0].value;
        this.ringToggle.addEventListener('change', () => {
          this.querySelector('[data-ring-options]').hidden = !this.ringToggle.checked;
        });
      }
      this.form.addEventListener('submit', event => this.addToCart(event));
      this.updateVariant(false);
    }
    updateVariant(updateUrl) {
      const option = this.variant.selectedOptions[0];
      this.querySelector('[data-price]').textContent = option.dataset.price;
      const note = this.querySelector('[data-material-note]');
      note.textContent = option.dataset.material.includes('925') ? note.dataset.silver : note.dataset.plated;
      const ready = this.dataset.ready === 'true';
      const available = option.dataset.available === 'true';
      this.button.disabled = this.busy || !ready || !available;
      this.button.textContent = !ready ? this.dataset.preview : available ? this.dataset.add : this.dataset.unavailable;
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url);
      }
    }
    async addToCart(event) {
      event.preventDefault();
      if (this.busy || this.button.disabled || !this.form.reportValidity()) return;
      const data = new FormData(this.form);
      const inscription = String(data.get('properties[Back engraving]') || '').trim();
      const item = {id: data.get('id'), quantity: 1};
      if (inscription) item.properties = {'Back engraving': inscription};
      const items = [item];
      if (this.ringToggle?.checked) {
        const ring = this.querySelector('[data-ring-variant]').selectedOptions[0];
        if (!ring || ring.disabled) {
          this.error.textContent = this.dataset.unavailable;
          this.error.hidden = false;
          return;
        }
        items.push({id: ring.value, quantity: 1});
      }
      this.busy = true;
      this.button.disabled = true;
      this.button.textContent = this.dataset.busy;
      this.error.hidden = true;
      try {
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST', credentials: 'same-origin',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({items})
        });
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
        window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        this.error.textContent = error.message || this.dataset.error;
        this.error.hidden = false;
      } finally {
        this.busy = false;
        this.updateVariant(false);
      }
    }
  });
}
